import { Link } from 'react-router-dom';

interface NotFoundStateProps {
  message: string;
  backTo: string;
  backLabel: string;
  secondaryTo?: string;
  secondaryLabel?: string;
}

export default function NotFoundState({
  message,
  backTo,
  backLabel,
  secondaryTo,
  secondaryLabel,
}: NotFoundStateProps) {
  return (
    <div className="mx-auto flex max-w-[1440px] flex-col items-center justify-center px-4 py-24 text-center md:px-6">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-200">
        <i className="ri-file-warning-line text-3xl text-secondary-400"></i>
      </span>
      <h1 className="mt-5 font-heading text-xl font-bold text-foreground-950">内容不存在</h1>
      <p className="mt-2 max-w-md text-sm text-secondary-500">{message}</p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        <Link
          to={backTo}
          className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-arrow-left-line"></i>
          {backLabel}
        </Link>
        {secondaryTo && (
          <Link
            to={secondaryTo}
            className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            <i className="ri-home-4-line"></i>
            {secondaryLabel}
          </Link>
        )}
      </div>
    </div>
  );
}